import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../css/subPages.css";

import Header from "./Header";
import StartToday from "./StartToday";
import Footer from "../../components/Footer";

export default function FAQ() {
  return (
    <>
      <Header pageSectionId="informationSection" />
      <Container className="subPageContainer">
        <Row className="pt-3 mb-3">
          <Col sm={12} className="text-center">
            <div className="subPageHeadingContainer">
              <h3 className="subPageHeadingText">
                FREQUENTLY ASKED QUESTIONS (FAQs)
              </h3>
            </div>
          </Col>
        </Row>
        <Row className="pt-3 mb-3">
          <Col className="mb-4">
            <ol className="listItems">
              <li className="mb-4">
                <h5 className="subPageListItems">
                  <b>Why should I consider refinancing? </b>
                  <br />
                  <br />
                  Based on what you and your spouse decide, refinancing could be
                  the right solution to:
                  <br />
                  <br />
                  <ul>
                    <li>
                      Remove one spouse from the mortgage (and from repayment
                      responsibilities)
                    </li>
                    <li>
                      Secure cash from the home’s equity to consolidate debts,
                      cover big expenses like college or home repairs, create an
                      emergency fund, or invest elsewhere{" "}
                    </li>
                    <li>
                      Switch from an adjustable-rate mortgage (ARM) to a
                      fixed-rate mortgage{" "}
                    </li>
                    <li>
                      Lock in a lower interest rate for lower mortgage payments
                      and better cash flow
                    </li>
                  </ul>
                </h5>
              </li>
              <li className="mb-4">
                <h5 className="subPageListItems">
                  <b>
                    My ex-spouse was ordered by the court to make house
                    payments, but I’m still on the mortgage as a co-borrower.
                    Will those payments hurt my chances of getting a new
                    mortgage?
                  </b>
                  <br />
                  <br />
                  No, because your ex-spouse is the court-ordered responsible
                  party.
                </h5>
              </li>
              <li className="mb-4">
                <h5 className="subPageListItems">
                  <b>When should I start working with you? </b>
                  <br />
                  <br />
                  As early as possible so I can review proposals and make sure
                  the final divorce settlement agreement aligns with your future
                  mortgage plans.
                </h5>
              </li>
              {/* <li className="mb-4">
                <h5 className="subPageListItems">
                  <b>
                    Working with my current lender will make things easier.{" "}
                  </b>
                  <br />
                  <br />
                  Only if they’re trained and certified in divorce lending. A
                  CDLP® has the knowledge, tools, and resources to represent
                  your needs and quickly fix any conflicts during the process.
                </h5>
              </li> */}
            </ol>
          </Col>
        </Row>
        <StartToday />
      </Container>
      <Footer />
    </>
  );
}
